import angular from 'angular';
import uiRouter from 'angular-ui-router';
import codedmedicalrecordsComponent from './codedmedicalrecords.component';

let codedmedicalrecordsModule = angular.module('codedmedicalrecords', [
  uiRouter
])

.component('codedmedicalrecords', codedmedicalrecordsComponent);

export default codedmedicalrecordsModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/codedmedicalrecords/codedmedicalrecords.js